import * as React from "react";
const SvgFiRrHandLove = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-hand-love_svg__a)">
      <path
        fill="#062147"
        d="M22.943 1.714a3.01 3.01 0 0 0-2.439-.674C19.076 1.272 18 2.59 18 4.107v4.077A3 3 0 0 0 17 8a2.98 2.98 0 0 0-2 .78A2.98 2.98 0 0 0 13 8c-.352 0-.686.072-1 .184V3.107C12 1.59 10.924.272 9.497.041a3 3 0 0 0-2.439.674 3 3 0 0 0-1.057 2.286v10.697l-.955-.89A3 3 0 0 0 .94 17.18l4.457 4.297A8.96 8.96 0 0 0 11.643 24H19c2.757 0 5-2.243 5-5V4c0-.88-.385-1.714-1.057-2.286M17 10c.551 0 1 .45 1 1v2c0 .551-.449 1-1 1s-1-.449-1-1v-2c0-.55.45-1 1-1m-4 0c.551 0 1 .45 1 1v2c0 .551-.449 1-1 1s-1-.449-1-1v-2c0-.55.45-1 1-1m9 9c0 1.654-1.346 3-3 3h-7.357a6.97 6.97 0 0 1-4.858-1.96l-4.468-4.307a1.005 1.005 0 0 1-.047-1.417 1 1 0 0 1 .695-.315c.272.008.52.086.715.27l2.637 2.461A1.001 1.001 0 0 0 8 16.002V3a1.001 1.001 0 0 1 1.176-.985c.462.075.824.555.824 1.092V13c0 1.654 1.346 3 3 3a2.98 2.98 0 0 0 2-.78c.532.48 1.23.78 2 .78 1.654 0 3-1.346 3-3V4.107c0-.538.362-1.018.825-1.093.303-.046.595.031.823.224.224.19.353.468.353.762z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-hand-love_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrHandLove;
